import type { ReactNode } from 'react';

export const symbol_upload_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-140h580q13 0 21.5 8.5T800-110q0 13-8.5 21.5T770-80H190q-13 0-21.5-8.5T160-110q0-13 8.5-21.5T190-140Zm200-100q-13 0-21.5-8.5T360-270v-250H260q-19 0-26.5-16.5T237-568l219-282q5-6 11-8.5t13-2.5q7 0 13 2.5t11 8.5l218 282q11 15 3.5 31.5T699-520h-99v250q0 13-8.5 21.5T570-240H390Zm30-60h120v-297h84L480-782 336-597h84v297Zm60-297Z"
		/>
	</svg>
);
